export const PrivacyPolicyData = {
  heading: "Salontym - Salon at Home Privacy Policy",

  introduction:
    "At Salontym - Salon at Home, your privacy is our priority, and we take it very seriously. Our Privacy Policy is designed to clearly explain our privacy practices and principles. We have crafted this policy in a user-friendly format to ensure that our visitors can easily navigate and understand the contents of our website, www.salontym.com. We are dedicated to handling your personal information with the highest level of care and respect. This Policy has been created to safeguard your personal information and ensure its confidentiality.",

  personalData: [
    {
      title:
        "We collect various types of personal data about you, including but not limited to:",
    },
    {
      content: [
        {
          heading: "1. Contact Data:",
          content:
            "Your mailing or home address, location, email addresses, and phone number.",
        },
        {
          heading: "2. Identity and Profile Data:",
          content:
            "Your name, username or similar identifiers, photographs, and gender.",
        },
        {
          heading: "3. Marketing and Communications Data: ",
          content:
            "Your address, email address, information posted in service requests, offers, wants, feedback, comments, pictures and discussions in our blog and chat boxes, responses to user surveys and polls, your preferences in receiving marketing communications from us and our third parties, and your communication preferences. We also collect your chat and call records when you communicate with service professionals through the platform.",
        },
      ],
    },
  ],

  FacialData:
    "Salontym collects facial data exclusively to enhance user experience through personalized services. Our application uses facial data to detect potential concerns on your face, aiming to provide customized solutions for improved outcomes. Rest assured, all collected data is handled with utmost privacy and is solely used to enhance your overall experience within the app.",

  privacyPolicy:
    "This privacy policy outlines how ThinkAi Innovations Private Limited uses and protects any information you provide when using this website. ThinkAi Innovations Private Limited is committed to ensuring your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, you can be assured that it will only be used in accordance with this privacy statement.",
  privacyPolicyParaTwo:
    " ThinkAi Innovations Private Limited may update this policy from time to time by modifying this page. You should check this page periodically to ensure that you are happy with any changes.",

  information: [
    { content: "Name and job title" },
    { content: "Contact information, including email address" },
    {
      content:
        "Demographic information such as postcode, preferences, and interests",
    },
    { content: "Other information relevant to customer surveys and/or offers" },
  ],

  whatWeDo: [
    {
      title:
        "We require this information to understand your needs and provide you with a better service, including for the following reasons:",
    },
    {
      points: [
        { content: "Internal record keeping." },
        { content: "Improving our products and services." },
        {
          content:
            "Sending promotional emails about new products, special offers, or other information we think you may find interesting using the email address you have provided.",
        },
        {
          content:
            "Contacting you for market research purposes. We may contact you by email, phone, fax, or mail.",
        },
        {
          content:
            "email, phone, fax, or mail. Customizing the website according to your interests ",
        },
      ],
    },
  ],

  security:
    "We are committed to ensuring that your information is secure. To prevent unauthorized access or disclosure, we have implemented suitable measures.",

  cookies:
    "A cookie is a small file that asks permission to be placed on your computer's hard drive. Once you agree, the file is added, and the cookie helps analyze web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes, and dislikes by gathering and remembering information about your preferences.",
  cookiesParaTwo:
    " We use traffic log cookies to identify which pages are being used. This helps us analyze data about webpage traffic and improve our website to tailor it to customer needs. We only use this information for statistical analysis purposes, and then the data is removed from the system.",
  cookiesParaThree:
    " Overall, cookies help us provide you with a better website by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us. ",
  cookiesParaFour:
    "You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.",

  personalInformation: [
    {
      title:
        "You may choose to restrict the collection or use of your personal information in the following ways:",
    },
    {
      points: [
        {
          one: "Whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the ",
        },
        {
          two: "information to be used by anybody for direct marketing purposes. If you have previously agreed to us using your personal information for direct marketing purposes you may change your mind at any time by writing to or emailing us at support@salontym.com. ",
        },
      ],
    },
    {
      information:
        "We will not sell, distribute, or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.",
    },
    {
      informationNextPara:
        "If you believe that any information we are holding about you is incorrect or incomplete, please write to or email us as soon as possible at the above address. We will promptly correct any information found to be incorrect.",
    },
  ],

  Terms: {
    paraOne:
      "The Website Owner, including subsidiaries and affiliates (“Website” or “Website Owner” or “we” or “us” or “our”) provides the information contained on the website or any of the pages comprising the website (“website”) to visitors (“visitors”) (cumulatively referred to as “you” or “your” hereinafter) subject to the terms and conditions set out in these website terms and conditions, the privacy policy, and any other relevant terms and conditions, policies, and notices which may be applicable to a specific section or module of the website.",

    paraTwo:
      "Welcome to our website. If you continue to browse and use this website, you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern ThinkAi Innovations Private Limited's relationship with you in relation to this website.",

    paraThree:
      "The term 'ThinkAi Innovations Private Limited' or 'us' or 'we' refers to the owner of the website whose registered/operational office is B-19, Sector 64, Noida, Uttar Pradesh 201301. The term 'you' refers to the user or viewer of our website.",
  },

  useTerms: [
    {
      point:
        "The content of the pages of this website is for your general information and use only. It is subject to change without notice.",
    },
    {
      point:
        "Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness, or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors, and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.",
    },
    {
      point:
        "Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services, or information available through this website meet your specific requirements.",
    },
    {
      point:
        "This website contains material that is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.",
    },
    {
      point:
        "All trademarks reproduced in this website which are not the property of, or licensed to, the operator are acknowledged on the website.",
    },
    {
      point:
        "of, or licensed to, the operator are acknowledged on the website. Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.",
    },
    {
      point:
        "From time to time, this website may also include links to other websites. These links are provided for your convenience to provide further information.",
    },
    {
      point:
        "You may not create a link to this website from another website or document without ThinkAi Innovations Private Limited’s prior written consent.",
    },
    {
      point:
        "Your use of this website and any dispute arising out of such use of the website is subject to the laws of India or other regulatory authority.",
    },
  ],

  useTermsDescription:
    "We, as a merchant, shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any transaction, on account of the cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.",

  cancellation: [
    {
      heading:
        "ThinkAi Innovations Private Limited believes in helping its customers as far as possible and therefore has a liberal cancellation policy. Under this policy:",
    },
    {
      content: [
        {
          points:
            "Cancellations will be considered only if the request is made immediately after placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.",
        },
        {
          points:
            "ThinkAi Innovations Private Limited does not accept cancellation requests for perishable items like flowers, eatables, etc. However, a refund/replacement can be made if the customer establishes that the quality of the product delivered is not good.",
        },
        {
          points:
            "In case of receipt of damaged or defective items, please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within the same day of receipt of the products.",
        },
        {
          points:
            "In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within the same day of receiving the product. The Customer Service Team, after looking into your complaint, will take an appropriate decision.",
        },
        {
          points:
            "In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.",
        },
        {
          points:
            "In case of any refunds approved by ThinkAi Innovations Private Limited, it’ll take 6-8 days for the refund to be processed to the end customer.",
        },
      ],
    },
  ],
  contactTitle: "You may contact us using the information below:",

  contact: [
    {
      line: "Merchant Legal Entity Name: ThinkAi Innovations Private Limited",
    },
    { line: "Registered Address: B-19, Sector 64, Noida, 201301" },
    { line: "Operational Address: B-19, Sector 64, Noida, 201301" },
    { line: "Telephone No: 8510000223" },
    { line: "E-Mail ID: support@salontym.com" },
  ],

  serviceProvider:
    "If a service provider establishes contact with a client, whether directly or indirectly, without obtaining prior permission, they will be subject to a fine of 10,000 rupees. Moreover, we hold the authority to file an F.I.R against the service provider for such actions.",

  MissingItems: [
    {
      points:
        "At Salontym - Salon at Home, we understand the importance of trust and accountability in our services. When an expert enters a customer's home to provide services, we expect them to conduct themselves professionally and responsibly. If a customer informs us of any missing items while the service is ongoing, we take immediate action against the expert responsible for the oversight.",
    },
    {
      points:
        "However, it's essential to note that if a customer claims a missing item after the completion of the job, we cannot take responsibility for it. We encourage customers to promptly report any concerns during the service to ensure timely resolution. Our aim is to provide a seamless and satisfactory experience for all our users, and your cooperation in this matter is highly appreciated.",
    },
    {
      points:
        "If you have any questions or need further clarification regarding our policy on missing items, please don't hesitate to contact us at support@salontym.com.",
    },
  ],

  collectionPN:
    "We value your privacy and are committed to being transparent about the information we collect. This update to our privacy policy includes details about the collection of phone numbers when you use our app.",

  collectionPurpose: [
    {
      title:
        "We may collect your phone number for the sole purpose of providing you with specific services or functionalities within our app. This may include, but is not limited to:",
    },
    [
      {
        heading: "Account Verification:",
        points:
          " We may use your phone number to verify your account and ensure the security of your data.",
      },
      {
        heading: "Two-Factor Authentication:",
        points:
          "In some cases, we may use your phone number to enable two-factor authentication for added security.",
      },
    ],
  ],

  Confidentiality:
    "We take the security and confidentiality of your phone number seriously. Your phone number will be stored securely and will not be shared with any third parties without your consent.",

  AccountDelect: [
    {
      title:
        "To delete your account and remove your saved data, please follow these steps:",
    },
    [
      { points: "1. Download the app from the appropriate App Store." },
      { points: "2. Log in using your registered mobile number." },
      { points: "3. Navigate to the profile section." },
      {
        points: "4. At the very bottom, select the 'Delete My Account' option.",
      },
      {
        points:
          "5. Your data will be completely removed from the system within 2 working days.",
      },
    ],
  ],
};
